import React from 'react';
import PropTypes from 'prop-types';
import { Table, Tooltip } from 'antd';
import styles from './TableList.module.scss';
import { XPagination } from '@/components/xqxc_ui';
import { tooltipStyle, tooltip, cellWidth } from '@/components/TableCell';
import { regFenToYuan } from '@/util/money';

function TableList(props) {

    const renderPrice = (val) => {
        if(val == undefined){
            return '-'
        }
        return '￥' + regFenToYuan(val);
    };

    const columns = [
        {
            title: '交易日期',
            dataIndex: 'transportName',
            key: 'transportName',
            width: '150px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '订单号',
            dataIndex: 'openTime',
            key: 'openTime',
            width: '150px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '钱包账号',
            dataIndex: 'walletId',
            key: 'walletId',
            width: '100px',
            align: 'center',
            render: tooltip
        },
        {
            title: '交易类型',
            dataIndex: 'totalBalance',
            key: 'totalBalance',
            width: '100px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '交易状态',
            dataIndex: 'balance',
            key: 'balance',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '交易方向',
            dataIndex: 'expectedBalance',
            key: 'expectedBalance',
            width: '100px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '交易金额',
            dataIndex: 'blockBalance',
            key: 'blockBalance',
            width: '100px',
            align: 'center',
            onCell: tooltipStyle,
            render: renderPrice
        },
        {
            title: '交易后余额',
            dataIndex: 'blockBalance',
            key: 'blockBalance',
            width: '100px',
            align: 'center',
            onCell: tooltipStyle,
            render: renderPrice
        },
        {
            title: '对方账户',
            dataIndex: 'statusDec',
            key: 'statusDec',
            width: '200px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '对方账户名称',
            dataIndex: 'statusDec',
            key: 'statusDec',
            width: '200px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
    ];

    return (
        <div className={styles.tableContainer}>
            <Table
                rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                rowKey={r => r.id}
                columns={columns}
                dataSource={props.renderData.dataList || []}
                pagination={false}
                scroll={{ y: true }}
            />
            <XPagination
                resultTotal={props.renderData.resultTotal}
                pageSize={props.renderData.pageSize}
                pageNum={props.renderData.pageNum}
                onChange={props.paginationChange}
            />
        </div>
    );
}

TableList.propTypes = {
    renderData: PropTypes.object.isRequired, // 表格数据源
    paginationChange: PropTypes.func.isRequired, // 分页操作
};

export default TableList;